import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { DOMSerializer } from '@tiptap/pm/model';
import { normalizeEmptyHtml } from 'utils/richText';
import { SUGGESTION_MARK_NAME } from './schema';

export function suggestionIdsIn(doc: ProseMirrorNode): string[] {
  const ids = new Set<string>();
  doc.descendants((node) => {
    const mark = node.marks.find(({ type }) => type.name === SUGGESTION_MARK_NAME);
    if (mark) ids.add(mark.attrs.id as string);
  });
  return [...ids];
}

export function serializeNote(doc: ProseMirrorNode): string {
  const serializer = DOMSerializer.fromSchema(doc.type.schema);
  const parts: string[] = [];
  doc.forEach((node) => {
    if (node.childCount > 0 && node.textContent === '') return;
    parts.push((serializer.serializeNode(node) as HTMLElement).outerHTML);
  });
  return normalizeEmptyHtml(parts.join(''));
}
